/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Checkbox, Icon, message} from 'antd'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../../Component/Pagination/Pagination'
import {Link} from 'react-router-dom'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {DatePicker, MuiPickersUtilsProvider, InlineDatePicker} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import moment from 'moment'
import RETAIL from '../BaseComponent/RETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class ReportLeave extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      leaves: [],
      modalEdit: false,
      printInfo: [],
      startDateEdit: '',
      endDateEdit: '',
      enable: true
    }
  }

  getAllLeaves = (
    params = sessionStorage.getItem('params'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    sortBy = sessionStorage.getItem('sortBy')
  ) => {
    http
      .get(
        `${
          RETAIL.RETAIL_MANAGE_DRIVER_LEAVE_REPORT
        }?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}&${sortBy}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            leaves: response.data.object.result,
            lengthProducts: response.data.object.countAll
          })
        } else {
          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  handlefromEdit = (date) => {
    this.setState({startDateEdit: date})
  }

  handletoEdit = (date) => {
    this.setState({endDateEdit: date})
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    this.getAllLeaves()
  }

  onResultFetched(data) {
    this.setState({
      leaves: data
    })
  }

  changeDropDown(data) {
    this.setState({
      leaves: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  openEdit = (num) => {
    this.setState({
      modalEdit: !this.state.modalEdit
    })
    sessionStorage.setItem('driverId', this.state.leaves[num].driverId)
    sessionStorage.setItem('leaveId', this.state.leaves[num].leaveId)

    // sessionStorage.setItem('startTime', this.state.leaves[num].startTime)
    // sessionStorage.setItem('endTime', this.state.leaves[num].endTime)
    this.setState({
      startDateEdit: this.state.leaves[num].startTime,
      endDateEdit: this.state.leaves[num].endTime
    })
  }
  toggleEdit = () => {
    this.setState({
      modalEdit: true
    })
  }

  cancelEdit = () => {
    this.setState({
      modalEdit: !this.state.modalEdit
    })
    sessionStorage.removeItem('driverId')
    sessionStorage.removeItem('leaveId')
    // this.setState({
    //     startDateEdit:''
    //     ,
    //     endDateEdit:''
    // })
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  confirmEdit = () => {
    var {enable} = this.state
    var startDateEdit = this.convertDigit(document.getElementById('startDateEdit').value)
    var endDateEdit = this.convertDigit(document.getElementById('endDateEdit').value)
    var driverId = sessionStorage.getItem('driverId')
    var leaveId = sessionStorage.getItem('leaveId')
    let data = {
      leaveId: leaveId,
      driverId: driverId,
      from: this.epochFrom(startDateEdit),
      to: this.epochFrom(endDateEdit),
      enabled: enable
    }
    http
      .post(`${RETAIL.RETAIL_MANAGE_DRIVER_LEAVE_EDIT}`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          message.success('مرخصی رساننده مورد نظر با موفقیت ویرایش شد')
          this.getAllLeaves()
        } else {
          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  filter() {}

  startDateEdit(props) {
    return <input className="form-control" {...props} />
  }

  endDateEdit(props) {
    return <input className="form-control" {...props} />
  }

  changeEnable = (e) => {
    this.setState({
      enable: e.target.checked
    })
  }

  exportExcel = () => {
    http
      .get(
        `${RETAIL.RETAIL_MANAGE_DRIVER_LEAVE_REPORT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['startTime'] = jMoment(excelReport[i]['startTime']).format('jYY/jMM/jDD')
            excelReport[i]['endTime'] = jMoment(excelReport[i]['receiveTime']).format('jYY/jMM/jDD')
            excelReport[i]['recordTime'] = jMoment(excelReport[i]['recordTime']).format('jYY/jMM/jDD HH:mm')

            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${RETAIL.RETAIL_MANAGE_DRIVER_LEAVE_REPORT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let excelColumns = [
      {title: 'عنوان', value: 'title'},
      {title: 'نوع', value: 'type'},
      {title: 'مقدار', value: 'value'}
    ]

    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let pageNumber = sessionStorage.getItem('pageNumber')
    var {startDateEdit, endDateEdit} = this.state
    let printCol = ['ردیف', 'رساننده', 'شروع مرخصی', 'پایان مرخصی', 'تاریخ ثبت', 'ثبت کننده', 'وضعیت']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش مرخصی های ثبت شده"
              headerColSpan={7}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((leave, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{leave.driverFirstName + ' ' + leave.driverLastName}</td>
                  <td>{jMoment(leave.startTime).format('jYYYY/jMM/jDD')}</td>
                  <td>{jMoment(leave.endTime).format('jYYYY/jMM/jDD')}</td>
                  <td>{jMoment(leave.recordTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>{leave.recorderFirstName + ' ' + leave.recorderLastName}</td>
                  <td>{leave.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش مرخصی های ثبت شده.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driverFirstName'}
                field={'driverFirstName'}
                title={'نام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driverLastName'}
                field={'driverLastName'}
                title={'نام خانوادگی'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'startTime'}
                field={'startTime'}
                title={'تاریخ شروع'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'endTime'}
                field={'endTime'}
                title={'تاریخ پایان'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recordTime'}
                field={'recordTime'}
                title={'تاریخ ثبت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recorderFirstName'}
                field={'recorderFirstName'}
                title={'نام ثبت کننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recorderLastName'}
                field={'recorderLastName'}
                title={'نام خانوادگی ثبت کننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/dashboard'}>به روزرسان</Link>
            </li>
            <li>گزارش مرخصی ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/setLeave"
                  url={RETAIL.RETAIL_MANAGE_DRIVER_LEAVE_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printLink=""
                  printComponent={this.printTable}
                  titleAdd=""
                  execelUrl={RETAIL.RETAIL_MANAGE_DRIVER_LEAVE_REPORT + '?export=true'}
                  excelColumns={excelColumns}
                />
                {/*<button className='filterBtn'>*/}
                {/*<i className="fa fa-search"></i>*/}
                {/*</button>*/}
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            {/*<div className='filterComponent'>*/}
            {/*<div className='filterInputs'>*/}
            {/*<div className='formComponent'>*/}
            {/*<label>نوع</label>*/}
            {/*<select className='form-control' id='type'>*/}
            {/*<option value=''>نوع</option>*/}
            {/*<option value='boolean'>boolian</option>*/}
            {/*<option value='character'>character</option>*/}
            {/*<option value='integer'>integer</option>*/}
            {/*<option value='long'>long</option>*/}
            {/*<option value='timestamp'>timestamp</option>*/}
            {/*<option value='decimal'>decimal</option>*/}
            {/*<option value='double'>double</option>*/}
            {/*<option value='date'>date</option>*/}
            {/*<option value='string'>string</option>*/}
            {/*<option value='custom'>custom</option>*/}
            {/*<option value='object'>object</option>*/}
            {/*</select>*/}
            {/*</div>*/}

            {/*<div className='formComponent'>*/}
            {/*<label>نام (انگلیسی)</label>*/}
            {/*<input className='form-control' id='name' type='text'/>*/}
            {/*</div>*/}
            {/*<div className='formComponent'>*/}
            {/*<label>عنوان</label>*/}
            {/*<input className='form-control' id='title' type='text'/>*/}
            {/*</div>*/}
            {/*<div className='formComponent'>*/}
            {/*<label>مقدار</label>*/}
            {/*<input className='form-control' id='value' type='text'/>*/}
            {/*</div>*/}

            {/*</div>*/}
            {/*<div className='filterOption'>*/}
            {/*<button className='confirmFilter' onClick={this.filter.bind(this)}>جست و جو</button>*/}
            {/*</div>*/}
            {/*</div>*/}
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>رساننده</td>
                    <td>شروع مرخصی</td>
                    <td>پایان مرخصی</td>
                    <td>تاریخ ثبت</td>
                    <td>ثبت کننده</td>
                    <td>فعال</td>
                    <td>ویرایش</td>
                  </tr>
                  {this.state.leaves.map((leave, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{leave.driverFirstName + ' ' + leave.driverLastName}</td>
                      <td>{jMoment(leave.startTime).format('jYYYY/jMM/jDD')}</td>
                      <td>{jMoment(leave.endTime).format('jYYYY/jMM/jDD')}</td>
                      <td>{jMoment(leave.recordTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>{leave.recorderFirstName + ' ' + leave.recorderLastName}</td>
                      <td>
                        {leave.enabled ? (
                          <img title={'فعال'} src={require('../../image/confirm.svg')} alt={'on'} />
                        ) : (
                          <img title={'غیر فعال'} src={require('../../image/ignor.svg')} alt={'off'} />
                        )}
                      </td>
                      <td>
                        <button onClick={() => this.openEdit(index)}>
                          <img src={require('../../image/editDriver.svg')} alt={''} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthProducts}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={RETAIL.RETAIL_MANAGE_DRIVER_LEAVE_REPORT}
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalEdit} toggle={this.toggleEdit} size="sm">
            <ModalHeader toggle={this.toggleEdit}>ویرایش مرخصی</ModalHeader>
            <ModalBody>
              <div className="modalForm">
                <div className="formComponent">
                  <label>از :</label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <InlineDatePicker
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                      onChange={this.handlefromEdit}
                      TextFieldComponent={this.startDateEdit}
                      id="startDateEdit"
                      name="startDateEdit"
                      value={startDateEdit}
                      readOnly
                      ref={(node) => (this.toDateInput = node)}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="formComponent">
                  <label>تا :</label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <InlineDatePicker
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                      onChange={this.handletoEdit}
                      TextFieldComponent={this.endDateEdit}
                      id="endDateEdit"
                      name="endDateEdit"
                      value={endDateEdit}
                      readOnly
                      ref={(node) => (this.toDateInput = node)}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="formComponent">
                  <Checkbox defaultChecked={this.state.enable} onChange={this.changeEnable}>
                    فعال / غیر فعال
                  </Checkbox>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.confirmEdit}>
                ویرایش مرخصی
              </button>
              <button className="cancelBtnModal" onClick={this.cancelEdit}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default ReportLeave
